import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import HamburgerMenu from "./HamburgerMenu";
import userDashboardBackground from "./assets/userdashboardbg.png";

function DashboardLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const menuItems = [
    { name: "Home", path: "/user-dashboard" },
    { name: "Wallet", path: "/wallet" },
    { name: "Submit", path: "/submit" },
    { name: "Orders", path: "/orders" },
    { name: "Profile", path: "/profile" },
  ];

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <div
      className="min-h-screen text-white font-[Montserrat]"
      style={{
        backgroundImage: `url(${userDashboardBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Top Nav */}
      <nav className="w-full relative flex items-center justify-between px-6 py-4 bg-black bg-opacity-60">
        {/* Left spacer to balance hamburger width */}
        <div style={{ width: 40 }} />

        {/* Right: Hamburger always visible */}
        <div className="flex items-center">
          <HamburgerMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />
        </div>
      </nav>

      {/* Nav Links: only visible on sm+ */}
      <div
        className="hidden sm:flex justify-center gap-6 py-2 bg-black bg-opacity-60"
        style={{ position: "relative", top: "-5px" }}
      >
        {menuItems.map((item) => (
          <span
            key={item.name}
            onClick={() => navigate(item.path)}
            style={{
              cursor: "pointer",
              fontSize: "18px",
              fontWeight: 700,
              fontFamily: "'Montserrat', sans-serif",
              textDecoration:
                location.pathname === item.path ? "underline" : "none",
            }}
          >
            {item.name}
          </span>
        ))}
      </div>

      {/* Page Content */}
      <div className="p-8 text-center bg-black bg-opacity-60 min-h-[calc(100vh-80px)]">
        {children}
      </div>
    </div>
  );
}

export default DashboardLayout;
